import { InvoiceLookupResolveService } from './invoices/shared/services/invoice-lookup-resolve.service';
import { InvoiceListComponent } from './invoices/invoice-list/invoice-list.component';
import { PaymentListComponent } from './payments/payment-list/payment-list.component';
import { PaymentLookupResolveService } from './payments/shared/services/payment-lookup-resolve.service';
import { TransactionListComponent } from './transactions/transaction-list/transaction-list.component';
import { TransactionLookupResolveService } from './transactions/shared/services/transaction-lookup-resolve.service';
import { RouteApplicationStartupResolveService } from '../core/route-application-startup-resolve.service';
import { BillingShellComponent } from './billing-shell/billing-shell.component';
import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { BillingReportLookupResolveService } from '@admin/billing/billing-report/shared/services/billing-report-lookup-resolve.service';
import { CustomerListComponent } from '@admin/billing/billing-report/customer-list/customer-list.component';
import { AuthGuard } from '../core/auth.guard';

const billingRoutes: Routes = [
  {
    path: 'billing',
    component: BillingShellComponent,
    canActivate: [AuthGuard],
    resolve: {
      appData: RouteApplicationStartupResolveService,
    },
    children: [
      {
        path: '',
        redirectTo: 'transactions/list',
        pathMatch: 'full',
      },
      {
        resolve: {
          appData: RouteApplicationStartupResolveService,
          lookupData: TransactionLookupResolveService,
        },
        path: 'transactions/list',
        component: TransactionListComponent,
        pathMatch: 'full',
        children: [
          {
            path: 'list/:code',
            component: TransactionListComponent,
          },
        ],
      },
      {
        resolve: {
          appData: RouteApplicationStartupResolveService,
          lookupData: TransactionLookupResolveService,
        },
        path: 'transactions/list/:code',
        component: TransactionListComponent,
      },
      {
        resolve: {
          appData: RouteApplicationStartupResolveService,
          lookupData: InvoiceLookupResolveService,
        },
        path: 'invoices/list',
        component: InvoiceListComponent,
        pathMatch: 'full',
        children: [
          {
            path: 'list/:code',
            component: InvoiceListComponent,
          },
          {
            path: 'list/:customer',
            component: InvoiceListComponent,
          },
          {
            path: 'list/:status',
            component: InvoiceListComponent,
          },
        ],
      },
      {
        resolve: {
          appData: RouteApplicationStartupResolveService,
          lookupData: InvoiceLookupResolveService,
        },
        path: 'invoices/list/:code',
        component: InvoiceListComponent,
      },
      {
        resolve: {
          appData: RouteApplicationStartupResolveService,
          lookupData: PaymentLookupResolveService,
        },
        path: 'payments/list',
        component: PaymentListComponent,
        pathMatch: 'full',
        children: [
          {
            path: 'list/:paymentCode',
            component: PaymentListComponent,
          },
        ],
      },
      {
        resolve: {
          appData: RouteApplicationStartupResolveService,
          lookupData: PaymentLookupResolveService,
        },
        path: 'payments/list/:paymentCode',
        component: PaymentListComponent,
      },
      {
        resolve: {
          appData: RouteApplicationStartupResolveService,
          lookupData: BillingReportLookupResolveService,
        },
        path: 'report/list',
        component: CustomerListComponent,
        pathMatch: 'full',
      },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(billingRoutes)],
  exports: [RouterModule],
})
export class BillingRoutingModule {}
